import {Subscription} from 'rxjs/Rx';
import {Observable} from 'rxjs';
import {Component, OnDestroy, OnInit} from '@angular/core';
import {LoadingService, LoggerService} from '../../../modules/hbs-services';

@Component({
    selector: 'hbs-loading',
    moduleId: module.id,
    templateUrl: './loading.component.html',
})
export class LoadingComponent implements OnInit, OnDestroy {

    loading: boolean = false;

    private subscription: Subscription;
    private oneTickSubscription: Subscription;
    private oneTick = Observable.timer(2000);   // 'Loading...' will appear after these milliseconds

    constructor(private loadingService: LoadingService,
                private logger: LoggerService) {
    }

    ngOnInit() {

        this.subscription = this.loadingService.subscribe((value: boolean) => {
            if (value) {

                if (this.oneTickSubscription) {
                    if (!this.oneTickSubscription.closed) {
                        // timer is active -> do nothing
                    } else {
                        // timer is not active -> subscribe
                        this.oneTickSubscription = null;
                    }
                }

                if (!this.oneTickSubscription) {
                    this.oneTickSubscription = this.oneTick.subscribe(x => this.loading = true);
                }
            } else {
                this.loading = false;
                if (this.oneTickSubscription) {
                    this.oneTickSubscription.unsubscribe();
                    this.oneTickSubscription = null;
                }

            }

        });

    }

    ngOnDestroy() {
        if (this.oneTickSubscription) {
            this.oneTickSubscription.unsubscribe();
        }
        this.subscription.unsubscribe();
    }

}
